// import external dependencies
import 'jquery';

//
// Swiper
// Use all on pages (mega menu)
//
import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';
import * as PhotoSwipe from 'photoswipe';
import * as PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

SwiperCore.use([Navigation]);

window.Swiper = Swiper;
window.SwiperCore = SwiperCore;
window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeUI_Default = PhotoSwipeUI_Default;

//
// import local dependencies
//
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateFoundersWall from './routes/founders-wall';
import singleSites from './routes/single-sites';
import singleCollections from './routes/single-collections';
import postTypeArchiveCollections from './routes/post-type-archive-collections';
import taxPeriod from './routes/tax-period';
import taxSiteCategory from './routes/tax-site_category';
import taxCountry from './routes/tax-country';
import podcasts from './routes/podcasts';
import templateDashboard from './routes/template-dashboard';
import templateSubscriptionLandingPage from './routes/template-subscription-landing-page';
import templateGiftRedemptionPreferences from './routes/template-gift-redemption-preferences';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons/faTwitterSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faInstagramSquare } from '@fortawesome/free-brands-svg-icons/faInstagramSquare';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faTv } from '@fortawesome/pro-regular-svg-icons/faTv';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { faChevronRight as faChevronRightSolid } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons/faAngleDoubleRight';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { faVolumeUp } from '@fortawesome/pro-light-svg-icons/faVolumeUp';
import { faLongArrowDown } from '@fortawesome/pro-light-svg-icons/faLongArrowDown';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faSignOut } from '@fortawesome/pro-regular-svg-icons/faSignOut';

import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';

//
// Icons
//
library.add(
  faTwitterSquare,
  faInstagram,
  faInstagramSquare,
  faFacebookSquare,
  faTv,
  faPlay,
  faAngleRight,

  faChevronRightSolid,

  faAngleUp,
  faAngleLeft,
  faAngleDoubleRight,
  faCaretUp,
  faCaretDown,
  faClock,
  faVolumeUp,
  faLongArrowDown,
  faChevronRight,
  faChevronDown,
  faChevronLeft,
  faChevronUp,
  faSignOut,
  faFacebookF,
  faTwitter,
  faWhatsapp,
  faEnvelope,
  faCheck
);

dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
    templateFoundersWall,
    // Single Sites
    singleSites,
    // Single Sites
    singleCollections,
    // Archive Collections
    postTypeArchiveCollections,
    // Taxonomies
    taxPeriod,
    taxSiteCategory,
    taxCountry,
    // Templates
    podcasts,
    // Dashboard
    templateDashboard,
    templateSubscriptionLandingPage,
    templateGiftRedemptionPreferences,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//
// Load Authorisation
//
import './modules/authorisation';
import './modules/account';
import './modules/coupons';
import './modules/currency';
import './modules/firstTime';

window.authorisation.setup();
window.account.setup();
window.coupons.setup();
window.currency.setup();
window.firstTime.setup();

//
// Setup Gift Subscriptions
//
import './modules/giftSubscriptions';

//
// Setup Gift Redemption Preferences
//
import './modules/giftRedemptionPreferences';
